// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1fXZD","footer":"Form_footer__172Jf"};